// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"HireCarInfo-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/HireCarInfo.mobile.scss
 ** module id = 905
 ** module chunks = 1
 **/